/**
 * Single template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import VideoBlock from './partials/VideoBlock';
import ProgramFaculty from './partials/ProgramFaculty';
import Faculty from './partials/Faculty';
import ProgramCurriculum from './partials/ProgramCurriculum';
import Faq from './partials/Faq';
import HowItWorks from './partials/HowItWorks';
import ProgramCurriculumGrid from './partials/ProgramCurriculumGrid';
import ProgramCost from './partials/ProgramCost';
import ContactForm from './partials/ContactForm';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Single';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
  Logger.info(`${NAME} > init`);

  const videoDom = document.querySelector('.video-block');
  if (videoDom) new VideoBlock(videoDom).init();

  const facultyDom = document.querySelector('.program-faculty');
  if (facultyDom) new ProgramFaculty(facultyDom).init();

  const facultySliderDom = document.querySelector('.faculty');
  if (facultySliderDom) new Faculty(facultySliderDom).init();

  const curriculumDom = document.querySelector('.program-curriculum');
  if (curriculumDom) new ProgramCurriculum(curriculumDom).init();

  const faqDom = document.querySelector('.faq');
  if (faqDom) new Faq(faqDom).init();

  const howItWorksDom = document.querySelector('.how-it-works');
  if (howItWorksDom) new HowItWorks(howItWorksDom).init();

  const curriculumGridDom = document.querySelector('.program-curriculum-grid');
  if (curriculumGridDom) new ProgramCurriculumGrid(curriculumGridDom).init();

  const costDom = document.querySelector('.program-cost');
  if (costDom) new ProgramCost(costDom).init();

  document.querySelectorAll('.contact-form').forEach((dom) => new ContactForm(dom).init());
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
